<template>
  <v-card 
    v-if="!folderData.hidden || isAdmin" 
    :class="{
      'strategio-hidden-item': folderData.hidden,
      'elevation-9': folderData.isMoving
    }" 
    :style="[
      {'width': getFolderSize()},
      {'height': isSearching ? '56px' : '350px'},
      {'display': 'inline-block'},
      {'margin': '8px'},
      {'background-color': 'white'},
      {'border-radius': '20px'}
    ]"
  >
    <!-- <div v-if="isNestedHeredable()">
      <div class="strategio-folder-card-nested-title">{{isNestedHeredable() ? getParentFoldersNames(folderData) : ''}}</div>
      <v-divider></v-divider>
    </div> -->
    <!-- <v-card-title class="pa-0" :style="`height:56px; background-color: ${colorTheme.background}FF`"> -->
    <v-card-title class="pa-0"
      :style="[
        {'height': '56px'},
        {'background-color': `${colorTheme.background}`},
        {'opacity': '1'}
      ]"
    >
      <v-layout row fill-height>
        <v-flex xs2
          v-if="isAdmin"
          class="layout align-center justify-center"
        >
          <div v-if="$route.params.folderID == 0 && folderData.inherited > 0">
            <v-tooltip top
              class="ml-2"
            >
              <v-icon slot="activator" color="white">low_priority</v-icon>
              <span>Vinculado a carpeta base</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs8 class="layout align-center">
          <span
            :style="[
              {'white-space': 'initial'},
              {'display':'visible'},
              {'color': colorTheme.text}
            ]"
            class="strategio-folder-card-title align-center"
            @click="enterFolder(folderData.itemID)"
          >
            {{folderData.itemName}}
          </span>
          <v-spacer></v-spacer>
        </v-flex>
        <v-flex xs2 class="layout align-center">
          <template v-if="toUpdateOn">
            <v-checkbox
              v-if="!(folderData.heritable > 0) && !folderData.inherited"
              :value="true"
              v-model="toUpdate.checked"
              hide-details
              color="white"
            ></v-checkbox>
          </template>
          <template v-else>
            <div class="">
              <item-menu :item="folderData" v-if="isAdmin" :is-searching="isSearching"></item-menu>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-layout style="height:calc(100% - 56px);" column v-if="!isSearching">
      <v-flex xs6 style="">
        <v-layout column>
          <v-layout row
            fill-height
            :style="[
              {'height': '35px'},
              {'background-color': colorTheme.background},
              {'color': 'white'},
              {'font-size': '11px'}
            ]"
          >
            <v-layout align-center :style="`background-color:${getAlphaedColor('#00000025')};color:${colorTheme.text}`">
              <template v-if="isAdmin">
                <v-flex text-xs-center xs6
                  style="cursor:pointer;"
                  @click="addInnerFolder(folderData)"
                >Agregar Carpeta</v-flex>
                <template v-if="!folderData.heritable">
                  <span :style="`font-size:27px;color:${getAlphaedColor('#00000050')};font-weight:200`">|</span>
                  <v-flex text-xs-center xs6
                    style="cursor:pointer;"
                    @click="manageInnerReportsPermissions(folderData)"
                  >Usuarios</v-flex>
                </template>

              </template>
              <template v-else>
                <v-flex style="" class="pl-3">
                  Lista de Carpetas
                </v-flex>
              </template>
            </v-layout>
          </v-layout>

          <v-flex style="">
            <v-layout column>
              <template v-if="partitionedChildren.folders.list.length > 0">
                <v-flex
                  :key="item.itemID"
                  v-for="(item, index) in partitionedChildren.folders.list"
                  v-if="index < 4"
                >
                  <v-layout class="align-center" style="height:27px;font-size:11px;color:gray;padding-left:13px">
                    <template v-if="index < 3">
                      <div
                        class="layout align-center"
                        style="width:100%;height:100%;cursor:pointer;"
                        @click="enterFolder(item.itemID)"
                      >
                        <img height="80%" :src="require('@/assets/icons/folder-icon.png')" alt="folder-icon">
                        <span
                          class="pl-2"
                        >
                          {{item.itemName}}
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <span style="font-size:18px;font-weight:bold;padding-left:27px;">...</span>
                    </template>
                  </v-layout>
                    <v-divider v-if="index < 3"></v-divider>
                </v-flex>
                
              </template>
              <template v-else>
                <v-flex>
                  <v-layout class="align-center px-3" style="height:27px;font-size:12px;color:gray;">
                    No tiene carpetas
                    <v-spacer></v-spacer>
                    <v-btn :disabled="false" v-if="isAdmin" icon outline color="grey" class="ma-0" style="width:16px;height:16px;"
                      @click="addInnerFolder(folderData)"
                    >
                      <v-icon style="font-size:13px">add</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        
      </v-flex>
      <!-- Reportes -->
      <v-flex xs6 style="">
        <v-layout column>
          <v-layout row
            fill-height
            :style="[
              {'height': '35px'},
              {'background-color': colorTheme.background},
              {'color': 'white'},
              {'font-size': '11px'}
            ]"
          >
            <v-layout align-center :style="`background-color:${getAlphaedColor('#00000025')};color:${colorTheme.text}`">
              <template v-if="isAdmin">
                <v-flex text-xs-center xs6
                  style="cursor:pointer;"
                  @click="addInnerReport(folderData)"
                >Agregar Reporte</v-flex>
              </template>
              <template v-else>
                <v-flex style="" class="pl-3">
                  Lista de Reportes
                </v-flex>
              </template>
            </v-layout>
          </v-layout>

          <v-flex style="">
            <v-layout column>
              <template v-if="partitionedChildren.reports.list.length > 0">
                <v-flex
                  :key="item.itemID"
                  v-for="(item, index) in partitionedChildren.reports.list"
                  v-if="index < 4"
                >
                  <v-layout class="align-center"
                    style="height:27px;font-size:11px;color:gray;padding-left:13px;"
                  
                  >
                    <template v-if="index < 3">
                      <div
                        class="layout align-center"
                        style="width:100%;height:100%;cursor:pointer;"
                        @click="showReport(item)"
                      >
                        <img height="80%" :src="require('@/assets/icons/report-icon.png')" alt="report-icon">
                        <span
                          class="pl-2"
                        >
                          {{item.itemName}}
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <span style="font-size:18px;font-weight:bold;padding-left:27px;">...</span>
                    </template>
                  </v-layout>
                    <v-divider v-if="index < 3"></v-divider>
                </v-flex>
                
              </template>
              <template v-else>
                <v-flex>
                  <v-layout class="align-center px-3" style="height:27px;font-size:12px;color:gray;">
                    No tiene reportes
                    <v-spacer></v-spacer>
                    <v-btn :disabled="false" v-if="isAdmin" icon outline color="grey" class="ma-0" style="width:16px;height:16px;"
                      @click="addInnerReport(folderData)"
                    >
                      <v-icon style="font-size:13px">add</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        
      </v-flex>

    </v-layout>
    <!-- <v-card-text style="background-color:#00000080">
      TEXTO
    </v-card-text> -->
  </v-card>
</template>

<script>
import {find, flatMap, reduceRight, partition} from 'lodash'

import ItemMenu from '../menus/item-menu.vue'
import userStorage from '../../storage/userStorage'
import eventBus from '../../utils/eventBus'
import reportsStorage from '../../storage/reportsStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'folder-list-item',
  data () {
    const user = userStorage.getUserInfo()
    return {
      isFavorite: false,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      test: []
    }
  },
  computed: {
    partitionedChildren () {
      let [isFolder, isReport] = partition(this.folderData.children, (child) => child.isFolder)
      return {
        folders: {
          list: isFolder || []
        },
        reports: {
          list: isReport || []
        }
      }
    }
  },
  methods: {
    getFolderSize () {
      return this.$vuetify.breakpoint.name === 'xs' ? '85%' : '220px'
    },
    getAlphaedColor (hrgba) {
      const hexToRGBA = (hrgba) => {
        let prgba = (hrgba.charAt(0) === '#') ? hrgba.substring(1, 9) : hrgba
        return {
          r: parseInt(prgba.substring(0, 2), 16),
          g: parseInt(prgba.substring(2, 4), 16),
          b: parseInt(prgba.substring(4, 6), 16),
          a: parseInt(prgba.substring(6, 8), 16) / 255
        }
      }
      return `rgba(${[Object.values(hexToRGBA(hrgba))].join(', ')})`
    },
    isNestedHeredable () {
      // eslint-disable-next-line
      return !(this.folderData.containedBy == this.$route.params.folderID)
    },
    getParentFolderName (_itemID) {
      let temp = ''
      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          temp = find(items, ({itemID}) => itemID === _itemID).itemName
        }
      })
      return temp
    },
    /* getParentFolder (item) {
      let temp = {}
      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          temp = find(items, ({itemID}) => itemID === item.containedBy)
        }
      })
      return temp
    }, */
    getParentFolder (item, folders) {
      let _folders = folders || [item]

      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          let itemIntent = find(items, ({itemID}) => itemID === item.containedBy)
          if (itemIntent) {
            _folders.push(itemIntent)
            this.getParentFolder(itemIntent, _folders)
          }
        }
      })
      return _folders
    },
    getParentFoldersNames (item) {
      return reduceRight(flatMap(this.getParentFolder(item), 'itemName'), (total, item) => {
        return `${total} > ${item}`
      })
    },
    enterFolder (folderID) {
      // eslint-disable-next-line
      if (folderID == this.$route.params.folderID) {
        eventBus.$emit('reload-items', {})
      } else {
        this.$router.push({name: 'MainPage', params: {folderID}})
      }
    },
    showReport (data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización ni de descarga', itsOk: 'warning'})
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank')
          reportsStorage.registerView(data.itemID, 'DOWNLOAD')
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning'})
        }
      } else {
        let _isFavorite = ''
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1'
        }
        this.$router.push(`/show-report/${data.itemID}${_isFavorite}`)
      }
    }
  },
  components: {
    ItemMenu
  },
  props: {
    folderData: {
      type: Object,
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    toUpdate: {
      type: Object,
      default () {
        return {}
      }
    },
    toUpdateOn: {
      type: Boolean,
      default () {
        return false
      }
    },
    colorTheme: {
      type: Object,
      default () {
        return {
          background: 'lightgray',
          text: 'black'
        }
      }
    },
    addInnerFolder: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerReport: {
      type: Function,
      default () {
        return () => {}
      }
    },
    manageInnerReportsPermissions: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>
<style>
.strategio-folder-card-nested-title {
  padding: 2px 14px 0px 16px;
  font-size: 12px;
  font-weight: 300;
  color: rgb(17, 66, 116);
  width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}
.strategio-folder-card-title {
  padding: 0px 0px 0px 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/folders/folder-list-item.vue